"use strict";

var _classCallCheck = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/createClass");

var _assertThisInitialized = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/inherits");

var _possibleConstructorReturn = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Node = _interopRequireDefault(require("./Node"));

var _copyShader = _interopRequireDefault(require("./copyShader"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * copy pixel with no interpolation (nearest pixel)
 * @prop {any} children content to render
 */


var NearestCopy = /*#__PURE__*/function (_react$Component) {
  _inherits(NearestCopy, _react$Component);

  var _super = _createSuper(NearestCopy);

  function NearestCopy() {
    var _this;

    _classCallCheck(this, NearestCopy);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_node", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onRef", function (node) {
      _this._node = node;
    });

    return _this;
  }
  /**
   * get a reference to the underlying Node instance
   * @return {Node}
   */


  _createClass(NearestCopy, [{
    key: "getNodeRef",
    value: function getNodeRef() {
      return this._node;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["children"]);

      return _react.default.createElement(_Node.default, _extends({}, rest, {
        ref: this._onRef,
        shader: _copyShader.default,
        blendFunc: {
          src: "one",
          dst: "one minus src alpha"
        },
        uniformsOptions: {
          t: {
            interpolation: "nearest"
          }
        },
        uniforms: {
          t: t
        }
      }));
    }
  }]);

  return NearestCopy;
}(_react.Component);

var _default = NearestCopy;
exports.default = _default;